import { api } from 'api'
import { path } from 'ramda'
import { CompanyRolePermission, User } from 'typings/common_defs'

interface UpdateUserAccountOptions {
  name: string
  email: string
  phoneNumber: string
}

export async function updateUserAccount({
  name,
  email,
  phoneNumber,
}: UpdateUserAccountOptions) {
  await api.put('/me', {
    name,
    email,
    phone_number: phoneNumber,
  })
}

export async function acceptInviteRequest(token: string) {
  await api.post('/company/accept_invite', {
    token,
  })
}

export interface UserProfile
  extends Pick<User, 'id' | 'name' | 'email' | 'isInternal'> {
  companyRolePermission: Pick<CompanyRolePermission, 'description'>
  companyUserNotificationOptions: Array<{
    type: string
    typeDisplayName: string
    frequencyOptions: Array<string>
    frequencyOptionsDisplayNames: Array<string>
    channel: string
  }>
  companyUserNotificationPreferences: Array<{
    type: string
    frequency: string
    frequencyDisplayName: string
    typeDescriptionDisplayName: string
    channel: string
  }>
}

export async function getMyProfile() {
  const data = await api.post(
    '/company/graphql_dispatch/my_profile_ac4ae2f9',
    {}
  )

  return path(['data', 'data', 'me'], data) as UserProfile
}

export async function updateEmailPreference(
  companyId: number,
  type: string,
  frequency: string
) {
  await api.post(`/company/${companyId}/notification_preferences`, {
    type,
    frequency,
    channel: 'email',
  })
}
